import { atom } from 'jotai';
import { Currency } from '../../types';

export const accountBalanceCurrenciesAtom = atom<Array<Currency>>([]);
